import { render, staticRenderFns } from "./PurchaseItem.vue?vue&type=template&id=7ffe37a5&scoped=true&"
import script from "./PurchaseItem.vue?vue&type=script&lang=ts&"
export * from "./PurchaseItem.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseItem.vue?vue&type=style&index=0&id=7ffe37a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe37a5",
  null
  
)

export default component.exports